<template>
  <div class="success-modal">
    <c-alert v-if="isModal" is-close-btn @close="onConfirm">
      <template #content>
        <div class="modal-content">
          <div class="message">
            <span>{{ resolvedMessage }}</span>
            <p class="message-sub">{{ SUB_MESSAGE }}</p>
          </div>
          <div class="buttons">
            <template v-if="!hideAdditionalInfoBtn">
              <span class="self-form-desc">
                추가정보를 입력하시면<br />더 빠르고 정확한 상담을 받을 수 있어요.
              </span>
              <c-button
                :size="CButtonSize.L"
                :type="CButtonType.Ghost"
                label="추가 정보 입력"
                @click="onMoveToSelfForm"
              />
            </template>
            <c-button
              :size="CButtonSize.L"
              :type="CButtonType.Fill"
              :variant="CButtonVariant.Tertiary"
              label="닫기"
              @click="onConfirm"
            />
          </div>
        </div>
      </template>
    </c-alert>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CAlert, CButton, CButtonSize, CButtonType, CButtonVariant } from '@aj-fe/aj-vue-core'

const DEFAULT_MESSAGE = '💌 신청이 완료됐어요\n아정당 대표번호(1833-3504)로\n전화드릴게요'

const SUB_MESSAGE = '마진을 줄여 최대현금을 돌려드리다 보니\n현재 상담 문의가 급증하여\n평소보다 연락이 늦어질 수 있어요.'

const props = withDefaults(
  defineProps<{
    isModal: boolean
    message?: string
    hashString?: string | null
    mainCategory?: string | null
    inflowPath?: string | null
    inflowPathDetail?: string | null
    hideAdditionalInfoBtn?: boolean
    nightCallbackTime?: string | null
  }>(),
  {
    message: '',
    hashString: null,
    mainCategory: null,
    inflowPath: null,
    inflowPathDetail: null,
    hideAdditionalInfoBtn: false,
    nightCallbackTime: null,
  },
)

// 야간 '낮에 받을게요'(거부) 시 → 콜백 안내 문구 우선 노출
const resolvedMessage = computed(() =>
  props.nightCallbackTime
    ? `💌 신청이 완료됐어요\n아정당 대표번호(1833-3504)로\n${props.nightCallbackTime} 전화드릴게요`
    : props.message || DEFAULT_MESSAGE,
)

const emit = defineEmits<{
  (e: 'confirm'): void
  (
    e: 'move-to-self-form',
    payload: {
      mainCategory: string | null
      hashString: string | null
      inflowPath: string | null
      inflowPathDetail: string | null
    },
  ): void
}>()

const onConfirm = () => emit('confirm')

const onMoveToSelfForm = () => {
  emit('move-to-self-form', {
    mainCategory: props.mainCategory,
    hashString: props.hashString,
    inflowPath: props.inflowPath,
    inflowPathDetail: props.inflowPathDetail,
  })
  emit('confirm')
}
</script>

<style lang="scss">
@use '@aj-fe/aj-vue-core/styles/theme' as theme;
@use './modal-shared' as shared;

.success-modal {
  @include shared.alert-card;

  .c-alert-container .modal-content {
    .message {
      @include theme.Body-M-500;
      color: var(--c-gray900, #1f2429);

      @media (max-width: 1024px) {
        @include theme.Body-S-500;
      }

      .message-sub {
        margin-top: 8px;
        @include theme.Body-S-400;
        color: var(--c-gray700, #575e64);

        @media (max-width: 1024px) {
          @include theme.Body-XS-400;
        }
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .self-form-desc {
        @include theme.Heading-XXS;
        color: var(--c-gray700, #575e64);

        @media (max-width: 1024px) {
          @include theme.Body-XS-500;
        }
      }
    }
  }
}
</style>
